import { Link as LinkS } from "react-scroll";
import styled from "styled-components";
import { COLORS } from "../../../const/colors";

export const ScrollupMain = styled(LinkS)`
  position: fixed;
  right: 2rem;
  bottom: ${(props) => (props.isscrollup ? "30px" : "-50px")};
  background-color: ${(props) =>
    props.light ? COLORS.DARK_BLUE : COLORS.WHITE};
  box-shadow: 0 4px 12px ${COLORS.BLACK_30};
  display: inline-flex;
  padding: 0.5rem;
  border-radius: 0.25rem;
  z-index: 10;
  opacity: 0.8;
  transition: 0.4s;
  cursor: pointer;

  @media screen and (max-width: 576px) {
    bottom: -50px;
  }
`;

export const ScrollupIcon = styled.i`
  font-size: 1.25rem;
  color: ${COLORS.ORANGE};

  &:hover {
    opacity: 1;
  }
`;
